import { initAcrawler } from '../../utils/acrawler';
import BaseInterface from '../base/index';
// import createXHR from '../../request/xhr';
// import createFetch from '../../request/fetch';
import {
  TypeAffLogin,
  TypeAffRegister,
  TypeAffForgetPwd,
  TypeAffInvite,
  TypeAffSubject,
  TypeAffResource,
  TypeAffRole,
  TypeAffUser,
  TypeAffSuper,
  TypeLogin,
  TypeQrcodeLogin,
  TypeRegister,
  TypeForgetPwd,
  TypeBind,
  TypeExtra,
  TypeRebind,
  TypePassword,
  TypeVerify,
  TypeCancel,
  TypeOpen,
  TypeAccount,
  TypeUser,
} from '../../types/web';
import {
  LoginAPI as AffLoginAPI,
  RegisterAPI as AffRegisterAPI,
  ForgetPwdAPI as AffForgetPwdAPI,
  InviteAPI as AffInviteAPI,
  SubjectAPI as AffSubjectAPI,
  ResourceAPI as AffResourceAPI,
  RoleAPI as AffRoleAPI,
  UserAPI as AffUserAPI,
  SuperAPI as AffSuperAPI,
} from './aff';
import LoginAPI from './login';
import QrCodeLoginAPI from './qrcode';
import BindAPI from './bind';
import ExtraAPI from './extra';
import RegisterAPI from './register';
import ForgetPwdAPI from './forgetPwd';
import RebindAPI from './rebind';
import PasswordAPI from './password';
import VerifyAPI from './verify';
import CancelAPI from './cancel';
import OpenAPI from './open';
import AccountAPI from './account';
import UserAPI from './user';

import { TypeInitProps } from '../../types/index';
export default class WebInterface extends BaseInterface {
  // private request: TypeRequest;
  public login: TypeLogin;
  public qrcodeLogin: TypeQrcodeLogin;
  public affLogin: TypeAffLogin;
  public register: TypeRegister;
  public affRegister: TypeAffRegister;
  public forgetPwd: TypeForgetPwd;
  public affForgetPwd: TypeAffForgetPwd;
  public password: TypePassword;
  public bind: TypeBind;
  public rebind: TypeRebind;
  public verify: TypeVerify;
  public extra: TypeExtra;
  public affInvite: TypeAffInvite;
  public affSubject: TypeAffSubject;
  public affResource: TypeAffResource;
  public affRole: TypeAffRole;
  public affUser: TypeAffUser;
  public affSuper: TypeAffSuper;
  public cancel: TypeCancel;
  public open: TypeOpen;
  public account: TypeAccount;
  public user: TypeUser;

  constructor(props: TypeInitProps) {
    super(props, 'web');
    const { printLog = false, acrawler = '' } = props;
    // log
    if (printLog) {
      console.log(
        '%cWebInterface Initial Props >>>>%O',
        'background: #222; color: #bada55',
        props
      );
    }
    // acrawler
    if (acrawler) {
      initAcrawler(acrawler, props);
    }

    // web interfaces
    let argus = { ...props, request: this.request };
    this.login = new LoginAPI(argus) as any;
    this.qrcodeLogin = new QrCodeLoginAPI(argus) as any;
    this.register = new RegisterAPI(argus);
    this.forgetPwd = new ForgetPwdAPI(argus);
    this.bind = new BindAPI(argus);
    this.rebind = new RebindAPI(argus);
    this.password = new PasswordAPI(argus);
    this.extra = new ExtraAPI(argus);
    this.verify = new VerifyAPI(argus);
    this.cancel = new CancelAPI(argus);
    this.open = new OpenAPI(argus);
    this.account = new AccountAPI(argus);
    this.user = new UserAPI(argus);
    // web aff interfaces
    this.affLogin = new AffLoginAPI(argus);
    this.affRegister = new AffRegisterAPI(argus);
    this.affInvite = new AffInviteAPI(argus);
    this.affSubject = new AffSubjectAPI(argus);
    this.affForgetPwd = new AffForgetPwdAPI(argus);
    this.affResource = new AffResourceAPI(argus);
    this.affRole = new AffRoleAPI(argus);
    this.affUser = new AffUserAPI(argus);
    this.affSuper = new AffSuperAPI(argus);
  }
}
